module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/declined-members/declined-members.component.css
// module id = ./src/app/components/declined-members/declined-members.component.css
// module chunks = main